import { CaseRepository } from '@telespot/domain';

export interface IAnyCasesForCaseTypeQuery {
  /**
   * Returns true if at least one case exists for the given case type.
   * Repository errors propagate so the caller can update its error state.
   */
  execute(caseTypeId: string): Promise<boolean>;
}

export class AnyCasesForCaseTypeQuery implements IAnyCasesForCaseTypeQuery {
  constructor(private readonly caseRepository: CaseRepository) {}

  public async execute(caseTypeId: string): Promise<boolean> {
    return this.caseRepository.anyFromType(caseTypeId);
  }
}
